import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="关于吃瓜视频，你可能想问"
          desc="整理了一些高频问题，帮助你快速了解平台定位、更新节奏与内容原则。"
        />

        <div className="divide-y divide-background-200/80 overflow-hidden rounded-2xl border border-background-200/80 bg-background-100/50">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <h3>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-start gap-3">
                      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"}`}>
                        {isOpen ? "−" : "+"}
                      </span>
                      <span className="text-[15px] font-bold text-foreground-900">{f.q}</span>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 pl-14 pr-6 md:pl-16">
                    <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}